import http from './index'
//拓首页轮播图
export const getrotation = function (data) {
  return http(`/api/rotation`, data, 'post')
}
//新闻咨询
export const getconsulting = function (data) {
  return http(`/api/consulting`, data, 'post')
}
//意向代理商
export const getintention_agen_add_sub = function (data) {
  return http(`/api/intention_agen_add_sub`, data, 'post')
}
//意向客户
export const getintention_customer_add_sub = function (data) {
  return http(`/api/intention_customer_add_sub`, data, 'post')
}
//咨询管理详情
export const getconsulting_details = function (data) {
  return http(`/api/consulting_details`, data, 'post')
}
//案例列表
export const getcase_management = function (data) {
  return http(`/api/case_management`, data, 'post')
}
//注册
export const index_freeTrial = function (data) {
  return http(`/index/OnlinePayment/freeTrial`, data, 'post')
}



// WEBPACK FOOTER //
// ./src/config/api.js